import { render } from "./AppLayoutDashboard.vue?vue&type=template&id=71ac6e80"
import script from "./AppLayoutDashboard.vue?vue&type=script&lang=js"
export * from "./AppLayoutDashboard.vue?vue&type=script&lang=js"
script.render = render

export default script